'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var index_es = require('./index.es-1f72f6f2.js');

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n"])));
var Icon = styled__default(index_es.FontAwesomeIcon)(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  font-size: 16px;\n  margin-right: 24px;\n  color: ", ";\n"], ["\n  font-size: 16px;\n  margin-right: 24px;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var TextContainer = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  font: 400 14px/16px ", ";\n  color: ", ";\n  ", ";\n"], ["\n  font: 400 14px/16px ", ";\n  color: ", ";\n  ",
    ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
}, function (props) { return (props.wrapText
    ? 'text-overflow: ellipsis; white-space: nowrap; overflow: hidden;'
    : null); });
var LinkContainer = styled__default.a(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  font: 400 14px/16px ", ";\n  color: ", ";\n  ", ";\n"], ["\n  font: 400 14px/16px ", ";\n  color: ", ";\n  ",
    ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.$secondary;
}, function (props) { return (props.wrapText
    ? 'text-overflow: ellipsis; white-space: nowrap; overflow: hidden;'
    : null); });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

exports.Container = Container;
exports.Icon = Icon;
exports.LinkContainer = LinkContainer;
exports.TextContainer = TextContainer;
